module.exports = __webpack_public_path__ + "img/screen-manual-10.657cbdba.png";